module.exports = new __parcel__URL__("hud_helpdesk_button.53dcd311.png").toString();